import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import AddToBagButton from '../../components/AddToBagButton/AddToBagButton';
import AppExclusiveButton from '../../components/AppExclusiveButton/AppExclusiveButton';
import BreakpointContext from '../../contexts/BreakpointContext';
import ProductPageContext from '../../contexts/ProductPageContext';
import AnalyticsTriggers from '../../analytics/analyticsTriggers';
import useHasGoldenStateAnalytics from '../../helpers/hasGoldenStateAnalytics';

function DesktopStickyAddToBag({
  brand,
  label,
  onAtbClick,
  activeButtonLabel,
  addToBagError,
  sizeTileSelectionRef,
  hasSelectableSoldOutSizeTiles,
  isAppExclusive,
  appExclusiveLabel,
}) {
  const [shouldScroll, setShouldScroll] = useState(false);
  const breakpoints = useContext(BreakpointContext);
  const ProductPageState = useContext(ProductPageContext);
  const hasGoldenStateAnalytics = useHasGoldenStateAnalytics();

  const getNavbarOffset = useCallback(() => (breakpoints.large ? 75 : 55), [breakpoints.large]);

  const handleScrollAddToBag = useCallback(() => {
    if (sizeTileSelectionRef && sizeTileSelectionRef.current) {
      const topPosition = sizeTileSelectionRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: topPosition - getNavbarOffset(),
        behavior: 'smooth',
      });
    }
  }, [getNavbarOffset, sizeTileSelectionRef]);

  const handleAtbClick = () => {
    window.digitalData.set('addToBag.stickyAtb', true);
    setShouldScroll(true);
    onAtbClick();
  };

  useEffect(() => {
    if (addToBagError?.value && shouldScroll) {
      setShouldScroll(false);
      handleScrollAddToBag();
      setTimeout(() => {
        AnalyticsTriggers.universalClick('jump link fail', 'add to bag', hasGoldenStateAnalytics, ProductPageState);
      }, 0);
    }
  }, [addToBagError, handleScrollAddToBag, shouldScroll, hasGoldenStateAnalytics, ProductPageState]);

  return (
    <div data-testid="desktop-sticky-add-to-bag">
      {isAppExclusive ? (
        <AppExclusiveButton
          brand={brand}
          label={appExclusiveLabel}
        />
      ) : (
        <AddToBagButton
          brand={brand}
          label={label}
          handleAddToBag={handleAtbClick}
          activeButtonLabel={activeButtonLabel}
          hasSelectableSoldOutSizeTiles={hasSelectableSoldOutSizeTiles}
        />
      )}
    </div>
  );
}

export default DesktopStickyAddToBag;

DesktopStickyAddToBag.propTypes = {
  brand: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onAtbClick: PropTypes.func.isRequired,
  activeButtonLabel: PropTypes.string.isRequired,
  addToBagError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
    PropTypes.number,
  ]),
};
